import { useState } from 'react';

const submitAddr = 'https://readdy.ai/api/form/daelr1rep053ijub1do0';

const contactOptions = [
  '提供爆料 / 行业线索',
  '采访邀约 / 合作',
  '内容纠错与澄清',
  '网站建议 / 其他',
];

type FormStatus = 'idle' | 'loading' | 'success';

export default function Contact() {
  const [status, setStatus] = useState<FormStatus>('idle');
  const [formError, setFormError] = useState('');
  const [category, setCategory] = useState(contactOptions[0]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    // 反垃圾：若蜜罐字段被填充，则不真正提交，仅展示与正常一致的成功反馈
    const honeypot = String(formData.get('website_alt') || '').trim();
    if (honeypot) {
      form.reset();
      setCategory(contactOptions[0]);
      setStatus('success');
      return;
    }

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key === 'website_alt') return; // 空蜜罐字段不随请求发出
        params.append(key, String(value));
      });

      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = responseText ? JSON.parse(responseText) : {};
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || '';

      const ok = response.ok && parsed?.code === 'OK' && !/spam/i.test(serverMsg);
      if (ok) {
        form.reset();
        setCategory(contactOptions[0]);
        setStatus('success');
      } else {
        setFormError(serverMsg || '提交失败，请稍后重试。');
        setStatus('idle');
      }
    } catch {
      setFormError('网络异常，提交未成功，请稍后再试。');
      setStatus('idle');
    }
  };

  return (
    <section id="contact" className="scroll-mt-24 bg-foreground-950">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-10 px-4 py-16 md:px-6 lg:grid-cols-[1fr_1.15fr]">
        <div className="text-background-50">
          <p className="flex items-center gap-2 text-sm font-medium text-accent-300">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
            SUBMIT A TIP
          </p>
          <h2 className="mt-2 font-heading text-3xl font-black tracking-tight">
            让真相多一个声音
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-background-100/80">
            你是圈内人、知情人士，或只是一个碰巧看见关键细节的人？欢迎把你知道的线索告诉我们。编辑部会对每条内容认真核实，并默认对投稿人信息做脱敏保护。
          </p>
          <ul className="mt-7 space-y-3 text-sm text-background-100/85">
            <li className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-950">
                <i className="ri-lock-2-line" />
              </span>
              支持匿名，隐私默认脱敏
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-950">
                <i className="ri-verified-badge-line" />
              </span>
              关键线索将进行多源核验
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-950">
                <i className="ri-message-3-line" />
              </span>
              内容纠错与澄清同样欢迎
            </li>
          </ul>
          <p className="mt-8 text-xs text-background-100/60">
            投稿与咨询邮箱：hello@99baoliao.example（示例联系方式，请以正式发布为准）
          </p>
        </div>

        <div className="rounded-lg bg-background-50 p-6 md:p-8">
          <h3 className="font-heading text-xl font-bold text-foreground-950">填写表单</h3>
          <p className="mt-1 text-xs text-foreground-500">带 * 为必填项。请尽量描述时间、地点与可验证的细节。</p>

          <form
            id="contact-form"
            data-readdy-form="daelr1rep053ijub1do0"
            onSubmit={handleSubmit}
            className="mt-6 space-y-4"
            noValidate
          >
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div>
                <label htmlFor="name" className="mb-1.5 block text-sm text-foreground-700">
                  称呼
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="怎么称呼你（可填网名）"
                  className="w-full rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                />
              </div>
              <div>
                <label htmlFor="email" className="mb-1.5 block text-sm text-foreground-700">
                  联系邮箱 <span className="text-primary-500">*</span>
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  placeholder="便于我们与你核实"
                  className="w-full rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                />
              </div>
            </div>

            <div>
              <label htmlFor="category" className="mb-1.5 block text-sm text-foreground-700">
                内容类型 <span className="text-primary-500">*</span>
              </label>
              <select
                id="category"
                name="category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
                className="w-full rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
              >
                {contactOptions.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label htmlFor="content" className="mb-1.5 block text-sm text-foreground-700">
                具体内容 / 线索描述 <span className="text-primary-500">*</span>
              </label>
              <textarea
                id="content"
                name="content"
                required
                maxLength={500}
                rows={5}
                placeholder="请尽量客观描述你了解的信息：发生了什么、大概的时间地点、有哪些可以交叉验证的细节……"
                className="w-full resize-none rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm leading-relaxed text-foreground-900 outline-none transition-colors focus:border-primary-400"
              />
              <p className="mt-1 text-right text-xs text-foreground-400">最多 500 字</p>
            </div>

            <div>
              <label htmlFor="anonymous" className="mb-1.5 block text-sm text-foreground-700">
                是否匿名
              </label>
              <select
                id="anonymous"
                name="anonymous"
                className="w-full rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
              >
                <option value="是，请匿名处理">是，请匿名处理</option>
                <option value="可实名（如选用请备注）">可实名（如选用请备注）</option>
              </select>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div>
                <label htmlFor="wechat" className="mb-1.5 block text-sm text-foreground-700">
                  微信号 / 电话（可选）
                </label>
                <input
                  id="wechat"
                  name="contact_phone"
                  type="text"
                  placeholder="便于紧急内容快速沟通"
                  className="w-full rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                />
              </div>
              <div>
                <label htmlFor="source" className="mb-1.5 block text-sm text-foreground-700">
                  线索来源（可选）
                </label>
                <input
                  id="source"
                  name="source"
                  type="text"
                  placeholder="亲眼所见 / 亲历 / 转述…"
                  className="w-full rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                />
              </div>
            </div>

            {/* 反垃圾蜜罐字段 */}
            <input
              type="text"
              name="website_alt"
              id="baoliao-website-check"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />

            {status === 'success' ? (
              <div className="flex items-center gap-3 rounded-md border border-accent-200 bg-accent-50 px-4 py-3 text-sm text-accent-800">
                <i className="ri-checkbox-circle-line text-lg" />
                已收到你的提交，编辑部会在核实后尽快与你联系，感谢支持！
              </div>
            ) : (
              formError && (
                <div className="flex items-center gap-3 rounded-md border border-primary-200 bg-primary-50 px-4 py-3 text-sm text-primary-700">
                  <i className="ri-error-warning-line text-lg" />
                  {formError}
                </div>
              )
            )}

            <button
              type="submit"
              disabled={status === 'loading'}
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {status === 'loading' ? (
                <>
                  <i className="ri-loader-4-line animate-spin" />
                  提交中…
                </>
              ) : (
                <>
                  <i className="ri-send-plane-line" />
                  提交给编辑部
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}